/**
 * Lightweight shimmering skeleton primitives.
 * Use these for loading states across the app.
 */
export function Skeleton({ className = "", testid }) {
  return (
    <div
      data-testid={testid}
      className={`vp-skeleton rounded-md ${className}`}
    />
  );
}

export function SkeletonRow({ cols = 4, testid }) {
  return (
    <div className="flex items-center gap-4 px-6 py-4 border-b border-[hsl(var(--border))] last:border-b-0" data-testid={testid}>
      <Skeleton className="h-12 w-12 shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3.5 w-2/5" />
        <Skeleton className="h-3 w-1/5" />
      </div>
      {Array.from({ length: cols - 2 }).map((_, i) => (
        <Skeleton key={i} className="h-3.5 w-20" />
      ))}
    </div>
  );
}

export function SkeletonCard({ testid }) {
  return (
    <div className="vp-card overflow-hidden" data-testid={testid}>
      <Skeleton className="aspect-square w-full rounded-none" />
      <div className="p-4 space-y-2">
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}

export function SkeletonStat({ testid }) {
  return (
    <div className="rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--bg))] p-3" data-testid={testid}>
      <Skeleton className="h-3 w-2/3 mb-2" />
      <Skeleton className="h-6 w-4/5" />
    </div>
  );
}

export function SkeletonList({ rows = 5 }) {
  return (
    <div className="vp-card overflow-hidden" data-testid="skeleton-list">
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export default Skeleton;
